if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector('.slider-counter--dots'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        
        // Add pagination dots functionality
        if (this.elements.dots) {
          this.elements.dots.querySelectorAll('.slider-counter__link--dots').forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              const mediaId = dot.dataset.target;
              if (mediaId) {
                this.setActiveMedia(mediaId, false);
              }
            });
          });
        }
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        // Initialize dots on page load
        this.updateDots();
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;
        if (mediaId) {
          this.setActiveMedia(mediaId, false);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        // Filter media by group if media grouping is enabled
        this.filterMediaByGroup(activeMedia);
        
        // Update pagination dots
        this.updateDots();

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            // activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      filterMediaByGroup(activeMedia) {
        // Only filter if media grouping is enabled
        if (!this.hasAttribute('media-grouping-enabled')) {
          return;
        }
        
        const activeGroup = activeMedia.getAttribute('data-media-group');
        if (!activeGroup) return;

        // Filter main media items
        this.elements.viewer.querySelectorAll('[data-media-group]').forEach((media) => {
          const mediaGroup = media.getAttribute('data-media-group');
          if (mediaGroup && mediaGroup !== activeGroup) {
            media.classList.add('media-group-hidden');
          } else {
            media.classList.remove('media-group-hidden');
          }
        });

        // Filter thumbnails
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-media-group]').forEach((thumbnail) => {
            const thumbnailGroup = thumbnail.getAttribute('data-media-group');
            if (thumbnailGroup && thumbnailGroup !== activeGroup) {
              thumbnail.classList.add('media-group-hidden');
            } else {
              thumbnail.classList.remove('media-group-hidden');
            }
          });
        }
        
        // Filter dots
        if (this.elements.dots) {
          this.elements.dots.querySelectorAll('[data-media-group]').forEach((dot) => {
            const dotGroup = dot.getAttribute('data-media-group');
            if (dotGroup && dotGroup !== activeGroup) {
              dot.classList.add('media-group-hidden');
            } else {
              dot.classList.remove('media-group-hidden');
            }
          });
        }
        
        // Update dots after filtering
        this.updateDots();
      }

      updateDots() {
        if (!this.elements.dots) return;
        
        const visibleDots = this.elements.dots.querySelectorAll('.slider-counter__link--dots:not(.media-group-hidden)');
        const activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active');
        const visibleMediaItems = this.elements.viewer.querySelectorAll('[data-media-id]:not(.media-group-hidden)');
        
        // Show/hide dots container based on visible media count
        if (visibleMediaItems.length <= 1) {
          this.elements.dots.style.display = 'none';
        } else {
          this.elements.dots.style.display = '';
        }
        
        // Remove active class from all dots
        this.elements.dots.querySelectorAll('.slider-counter__link--dots').forEach(dot => dot.classList.remove('slider-counter__link--active'));
        
        // Find the dot that matches the active media's target
        if (activeMedia && visibleDots.length > 0) {
          const activeMediaId = activeMedia.dataset.mediaId;
          const activeDot = this.elements.dots.querySelector(`.slider-counter__link--dots[data-target="${activeMediaId}"]:not(.media-group-hidden)`);
          if (activeDot) {
            activeDot.classList.add('slider-counter__link--active');
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}